import React, {
  useEffect,
  useState,
} from "react";
import AdminLayout from "./AdminLayout";

const AdminCbseDocument = () => {
  const [title, setTitle] =
    useState("");

  const [file, setFile] =
    useState(null);

  const [data, setData] =
    useState([]);

  /* FETCH */
  const fetchData = () => {
    fetch(
      " https://node.ilakshyaerp.in/api/cbse-documents"
    )
      .then((res) =>
        res.json()
      )
      .then((res) =>
        setData(
          Array.isArray(res)
            ? res
            : []
        )
      )
      .catch(() =>
        setData([])
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* UPLOAD */
  const handleUpload =
    async () => {
      if (
        !title ||
        !file
      ) {
        alert(
          "Enter title and choose file ❌"
        );
        return;
      }

      try {
        const formData =
          new FormData();

        formData.append(
          "title",
          title
        );

        formData.append(
          "file",
          file
        );

        const res =
          await fetch(
            " https://node.ilakshyaerp.in/api/cbse-documents/add",
            {
              method:
                "POST",
              body:
                formData,
            }
          );

        const result =
          await res.json();

        if (
          !res.ok
        ) {
          alert(
            result.message ||
              "Upload failed ❌"
          );
          return;
        }

        alert(
          result.message
        );

        setTitle("");
        setFile(
          null
        );

        fetchData();
      } catch {
        alert(
          "Network error ❌"
        );
      }
    };

  /* DELETE */
  const handleDelete =
    async (id) => {
      try {
        const res =
          await fetch(
            ` https://node.ilakshyaerp.in/api/cbse-documents/${id}`,
            {
              method:
                "DELETE",
              }
          );

        const result =
          await res.json();

        alert(
          result.message ||
            "Deleted successfully ✅"
        );

        fetchData();
      } catch {
        alert(
          "Delete failed ❌"
        );
      }
    };

  return (
    <AdminLayout>
      <div className="notice-page">

        <div className="notice-card">
          <h2>
            Upload CBSE Document
          </h2>

          <input
            placeholder="Title"
            value={title}
            onChange={(e) =>
              setTitle(
                e.target.value
              )
            }
          />

          <input
            type="file"
            onChange={(e) =>
              setFile(
                e.target
                  .files[0]
              )
            }
          />

          <button
            onClick={
              handleUpload
            }
          >
            Upload
          </button>
        </div>

        <div className="notice-table">
          <table>
            <tbody>
              {data.map(
                (d) => (
                  <tr
                    key={
                      d.id
                    }
                  >
                    <td>
                      {
                        d.title
                      }
                    </td>

                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          handleDelete(
                            d.id
                          )
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                )
              )}

              {data.length ===
                0 && (
                <tr>
                  <td
                    colSpan="2"
                    style={{
                      textAlign:
                        "center",
                    }}
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminCbseDocument;